<template>
  <div class="figure-container">

    <el-tabs type="border-card" v-model="activeTab">

      <el-tab-pane label="データの一覧" name="basic">
          <div class="figure-main-container figure-basic-container" :style="{ height: height }">
      <fixed-header-table :fixed="figure.figurePreview.basic.value != null && figure.figurePreview.basic.value.length > 0 && activeTab === 'basic'">
        <tr slot="header">
          <th>データ項目</th>
          <th>タイプ</th>
          <th>データ件数</th>
          <th>値（1行目）</th>
          <th>ユニーク数</th>
          <th>平均</th>
          <th>分散</th>
          <th>標準偏差</th>
          <th>最小値</th>
          <th>最大値</th>
          <th>中央値</th>
          <th>最頻値</th>
          <th>尖度</th>
          <th>歪度</th>
          <th>備考</th>
        </tr>
        <tr v-for="basic in figure.figurePreview.basic.value">
          <td :title="basic.column"><span class="td-wrapper">{{basic.column}}</span></td>
          <td>
            <div v-text="getXTypeByLabel(basic.xType).label"></div>
          </td>
          <td :title="basic.records | number_format('-')"><span class="td-wrapper">{{basic.records | number_format('-')}}</span></td>
          <td :title="basic.firstVal | number_format('-')"><span class="td-wrapper">{{basic.firstVal | number_format('-')}}</span></td>
          <td :title="basic.uniqueVals | number_format('-')"><span class="td-wrapper">{{basic.uniqueVals | number_format('-')}}</span></td>
          <td :title="basic.avg | number_format('-')"><span class="td-wrapper">{{basic.avg | number_format('-')}}</span></td>
          <td :title="basic.var | number_format('-')"><span class="td-wrapper">{{basic.var | number_format('-')}}</span></td>
          <td :title="basic.std | number_format('-')"><span class="td-wrapper">{{basic.std | number_format('-')}}</span></td>
          <td :title="basic.min | number_format('-')"><span class="td-wrapper">{{basic.min | number_format('-')}}</span></td>
          <td :title="basic.max | number_format('-')"><span class="td-wrapper">{{basic.max | number_format('-')}}</span></td>
          <td :title="basic.med | number_format('-')"><span class="td-wrapper">{{basic.med | number_format('-')}}</span></td>
          <td :title="basic.mod | number_format('-')"><span class="td-wrapper">{{basic.mod | number_format('-')}}</span></td>
          <td :title="basic.kurt | number_format('-')"><span class="td-wrapper">{{basic.kurt | number_format('-')}}</span></td>
          <td :title="basic.skew | number_format('-')"><span class="td-wrapper">{{basic.skew | number_format('-')}}</span></td>
          <td>
            <template v-if="dataCollectionColumn.indexOf(basic.column) === -1">
              <span v-if="isTransformable(basic)"><tooltip-icon placement="top" :content="'タイプを変更できます'"
                                                                icon="el-icon-refresh"></tooltip-icon></span>
            </template>
            <template v-if="basic.info && basic.info !== {}" v-for="infoCode in Object.keys(basic.info)">
              <span v-if="/^2\d{2}$/.test(infoCode)"><tooltip-icon placement="top" :content="getInfoMessage(infoCode)"
                                                                   icon="el-icon-info"></tooltip-icon></span>
              <span v-else-if="/^[34]\d{2}$/.test(infoCode)"><tooltip-icon placement="top"
                                                                           :content="getInfoMessage(infoCode)"
                                                                           icon="el-icon-warning"></tooltip-icon></span>
            </template>
          </td>
        </tr>
      </fixed-header-table>
    </div>
      </el-tab-pane>

      <el-tab-pane label="データの分布" name="dist" v-if="figure.figurePreview.dist">
        <template>
          <div class="figure-main-container figure-dist-container"
               v-if="activeTab === 'dist'"
               :style="{ height: height }">
            <dist-chart :dist="figure.figurePreview.dist" :yName="yName"
                        :categoryId="categoryId"
                        :initialColumnIndex="initialColumnIndex"
                        style="width: 100%;"></dist-chart>
          </div>
        </template>
      </el-tab-pane>

      <el-tab-pane label="データの評価" name="xeval" v-if="figure.figurePreview.xeval">
        <template>
          <div class="figure-main-container figure-xeval-container"
               v-show="activeTab === 'xeval'"
               :style="{ height: height }">
            <fixed-header-table
              :fixed="figure.figurePreview.xeval.value != null && figure.figurePreview.xeval.value.length > 0 && activeTab === 'xeval'">
              <tr slot="header">
                <th>項目名</th>
                <th
                  v-for="columnName in figure.figurePreview.xeval.header.slice(1)">
                  {{columnName}}
                  <tooltip-icon v-if="TIPS.hasOwnProperty(columnName)"
                                placement="right" :content="TIPS[columnName]"
                                style="margin-bottom: 3px;"></tooltip-icon>
                </th>
              </tr>
              <tr v-for="xeval in figure.figurePreview.xeval.value">
                <td :title="xeval.column"><span class="td-wrapper">{{xeval.column}}</span>
                </td>
                <td
                  v-for="columnName in figure.figurePreview.xeval.header.slice(1)"
                  :title="xeval[columnName]">
                  <span class="td-wrapper">{{xeval[columnName] | number_format('-')}}</span>
                </td>
              </tr>
            </fixed-header-table>
          </div>
        </template>
      </el-tab-pane>

      <el-tab-pane label="自己相関" name="acf" v-if="figure.figurePreview.acf">
        <template>
          <div class="figure-main-container figure-acf-container"
               v-show="activeTab === 'acf'" :style="{ height: height }">
            <acf-chart :acf="figure.figurePreview.acf"
                       style="width: 100%;"></acf-chart>
          </div>
        </template>
      </el-tab-pane>

      <el-tab-pane label="偏自己相関" name="pacf" v-if="figure.figurePreview.pacf">
        <template>
          <div class="figure-main-container figure-pacf-container"
               v-show="activeTab === 'pacf'"
               :style="{ height: height }">
            <pacf-chart :pacf="figure.figurePreview.pacf"
                        style="width: 100%;"></pacf-chart>
          </div>
        </template>
      </el-tab-pane>

    </el-tabs>

    <div class="figure-footer-container">
      <el-button type="info" @click="onClickResultDownload(figure.figures[activeTab])">結果をダウンロード</el-button>
      <template v-if="dataCollectionColumn.length > 0">
        <div class="spacer"></div>
        <div class="el-button el-button--info" type="info" @click="onClickJoinedCSVDownload()">
          <span>学習データをダウンロード</span>&nbsp;<tooltip-icon placement="top" :content="'オープンデータの紐づけを行った場合、データをダウンロード出来ます'"
                                                       icon="el-icon-info"></tooltip-icon>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ApiApiClient from '../../../api/api'
import DistChartCmp from '../../chart/dist.vue'
import AcfChartCmp from '../../chart/acf.vue'
import PacfChartCmp from '../../chart/pacf.vue'
import { Figure } from '../../../defines/model/figure'
import CommonUtil from '../../../utils/common'
import Messages from '../../../utils/messages'
import DownloadUtil from '../../../utils/donwload'
import { X_TYPE_DEFINE } from '../../../defines/model/model'

export default {
  name: 'FigureCmp',
  components: {
    'dist-chart': DistChartCmp,
    'acf-chart': AcfChartCmp,
    'pacf-chart': PacfChartCmp
  },
  props: {
    categoryId: '',
    figure: Figure,
    yName: '',
    dataCollections: Array,
    initialColumnIndex: {type: Number, default: 0},
    initialTab: {type: String, default: 'basic'}
  },
  data () {
    return {
      activeTab: '',
      height: '420px',
      dataCollectionColumn: []
    }
  },
  computed: {
    TIPS () {
      return {
        'AUC': '分類モデルにおいて最も一般的な指標。\n0.5～1.0の値を取り、数値が大きいほど有用度が高いと考えられます。\n一般に、0.55以上の項目はモデルに有用なデータとみなします。',
        'Cramer': 'データ項目と予測対象の関連性を示す指標。\n0～1の値を取り、数値が大きいほど有用度が高いと考えられます。\n一般に、0.3以上の項目はモデルに有用なデータとみなします。',
        'Cross-AIC': '予測対象におけるデータ項目の情報量を示す指標。\nマイナスの値ほど情報量が多く意味のあるデータとみなしますが、基準はなく項目どうしの比較に用います。',
        'CORR_Pearson': 'もっとも一般的な相関の値です。\n-1～1の値をとりますが、その絶対値が1に近い方ほど、\n予測対象との関係性があると言えます。'
      }
    }
  },
  created () {
    this.activeTab = this.initialTab
    this.dataCollectionColumn = CommonUtil.isNotEmpty(this.dataCollections) ? this.dataCollections.map(
      data => data.columns).reduce((array, column) => array.concat(column)) : []
  },
  methods: {
    getInfoMessage (code) {
      const message = Messages.getMessage(`I${code}`)
      if (CommonUtil.isEmpty(message)) {
        return '-'
      } else {
        return message
      }
    },
    onClickResultDownload (downloadUrl) {
      window.location.href = downloadUrl
    },
    onClickJoinedCSVDownload () {
      return ApiApiClient.downloadDs(this, { dsName: this.figure.dsName }).then(response => {
        const fileName = this.figure.dsName + '.csv'
        DownloadUtil.downloadCsvBlob(response.data, fileName)
      })
    },
    getXTypeByLabel (label) {
      return X_TYPE_DEFINE.filter(xType => xType.value === label)[0]
    },
    isTransformable (value) {
      const transformableTypes = value.transformableTypes || []

      // << temporary solution for time series model >>
      if (this.categoryId === 'TSA' && value.xType === 'time') {
        return false
      }

      return value.transformable === 1 || CommonUtil.isNotEmpty(transformableTypes)
    }
  }
}

</script>

<style scoped>
  .figure-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .figure-tab-menu {
    display: flex;
    flex-shrink: 0;
    border-top: 1px solid #c0d5ef;
  }

  .figure-tab-menu.el-menu.el-menu--horizontal {
    border-bottom: 1px solid #c0d5ef;
  }

  .figure-tab-menu.el-menu--horizontal >>> .el-menu-item {
    flex-grow: 1;
    color: #2456d4;
    text-align: center;
    text-decoration-line: underline;
    border: none;
    width: 200px;
    height: 48px;
    line-height: 50px;
  }

  .figure-tab-menu.el-menu--horizontal >>> .el-menu-item:hover,
  .figure-tab-menu.el-menu--horizontal >>> .el-menu-item.is-active {
    background-color: #6ba7ef;
    color: #fff;
    text-decoration: none;
    border: none;
  }

  .figure-main-container {
    padding: 0;
  }

  .figure-basic-container,
  .figure-xeval-container {
    padding: 16px 20px;
  }

  .figure-basic-container > div,
  .figure-xeval-container > div {
    height: 400px;
  }

  .figure-dist-container > div {
    height: 420px;
  }

  .figure-footer-container {
    padding: 16px;
    background-color: #fff;
    text-align: center;
    flex-shrink: 0;
  }

  .figure-footer-container >>> .el-button--info {
    width: 320px;
    height: 50px;
    vertical-align: middle;
  }

  .figure-footer-container >>> .tooltip-icon,
  .figure-footer-container >>> span {
    vertical-align: middle;
  }


  .figure-footer-container div.spacer {
    display: inline-block;
    width: 160px;
  }

  .td-wrapper {
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  th, td {
    width: 10rem !important;
  }

</style>
<style>
  .xeval-tooltip-popper.el-tooltip__popper.is-dark {
    max-width: 400px;
  }

  .el-table .table-cell-nowrap,
  .el-table .table-cell-nowrap .cell {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/figure/figure.vue